export enum ConcurrentsTypes {
  SHOW_PAGE = '@concurrents/SHOW_PAGE',
  GET_COMPANY_REQUEST = '@concurrents/GET_COMPANY_REQUEST',
  GET_COMPANY_SUCCESS = '@concurrents/GET_COMPANY_SUCCESS',
  GET_COMPANY_FAILURE = '@concurrents/GET_COMPANY_FAILURE',
  GET_PENALTIES_REQUEST = '@concurrents/GET_PENALTIES_REQUEST',
  GET_PENALTIES_SUCCESS = '@concurrents/GET_PENALTIES_SUCCESS',
  GET_PENALTIES_FAILURE = '@concurrents/GET_PENALTIES_FAILURE',
  GET_CERTIDOES_APF_REQUEST = '@concurrents/GET_CERTIDOES_APF_REQUEST',
  GET_CERTIDOES_APF_SUCCESS = '@concurrents/GET_CERTIDOES_APF_SUCCESS',
  GET_CERTIDOES_APF_FAILURE = '@concurrents/GET_CERTIDOES_APF_FAILURE',
  GET_CERTIDOES_SP_REQUEST = '@concurrents/GET_CERTIDOES_SP_REQUEST',
  GET_CERTIDOES_SP_SUCCESS = '@concurrents/GET_CERTIDOES_SP_SUCCESS',
  GET_CERTIDOES_SP_FAILURE = '@concurrents/GET_CERTIDOES_SP_FAILURE',
  GET_FOLLOWUP_REQUEST = '@concurrents/GET_FOLLOWUP_REQUEST',
  GET_FOLLOWUP_SUCCESS = '@concurrents/GET_FOLLOWUP_SUCCESS',
  GET_FOLLOWUP_FAILURE = '@concurrents/GET_FOLLOWUP_FAILURE',
  GET_BIDDINGS_REQUEST = '@concurrents/GET_BIDDINGS_REQUEST',
  GET_BIDDINGS_SUCCESS = '@concurrents/GET_BIDDINGS_SUCCESS',
  GET_BIDDINGS_FAILURE = '@concurrents/GET_BIDDINGS_FAILURE',
  GET_SANCTIONS_LIST_REQUEST = '@concurrents/GET_SANCTIONS_LIST_REQUEST',
  GET_SANCTIONS_LIST_SUCCESS = '@concurrents/GET_SANCTIONS_LIST_SUCCESS',
  GET_SANCTIONS_LIST_FAILURE = '@concurrents/GET_SANCTIONS_LIST_FAILURE',
  GET_MEMBERSHIP_DATA_REQUEST = '@concurrents/GET_MEMBERSHIP_DATA_REQUEST',
  GET_MEMBERSHIP_DATA_SUCCESS = '@concurrents/GET_MEMBERSHIP_DATA_SUCCESS',
  GET_MEMBERSHIP_DATA_FAILURE = '@concurrents/GET_MEMBERSHIP_DATA_FAILURE',
  ITENS_VENCIDOS_REQUEST = '@concurrents/ITENS_VENCIDOS_REQUEST',
  ITENS_VENCIDOS_SUCCESS = '@concurrents/ITENS_VENCIDOS_SUCCESS',
  ITENS_VENCIDOS_FAILURE = '@concurrents/ITENS_VENCIDOS_FAILURE',
  LIST_STRATEGIC_ASPECTS_REQUEST = '@concurrents/LIST_STRATEGIC_ASPECTS_REQUEST',
  LIST_STRATEGIC_ASPECTS_SUCCESS = '@concurrents/LIST_STRATEGIC_ASPECTS_SUCCESS',
  LIST_STRATEGIC_ASPECTS_FAILURE = '@concurrents/LIST_STRATEGIC_ASPECTS_FAILURE',
  PARTICIPACOES_RESUMO_REQUEST = '@concurrents/PARTICIPACOES_RESUMO_REQUEST',
  PARTICIPACOES_RESUMO_SUCCESS = '@concurrents/PARTICIPACOES_RESUMO_SUCCESS',
  PARTICIPACOES_RESUMO_FAILURE = '@concurrents/PARTICIPACOES_RESUMO_FAILURE',
  UPDATE_MEMBERSHIP = '@concurrents/UPDATE_MEMBERSHIP',
}

export interface PercentuaisType {
  desclassificacoes: number;
  inabilitacoes: number;
}

export type MotivoTipo = 'Desclassificação' | 'Inabilitação';
export interface MotivoType {
  tipo: MotivoTipo;
  descricao: string;
  ocorrencias: number;
}

export interface StrategicAspectsType {
  desclassificacoes: number;
  inabilitacoes: number;
  total_participacoes: number;
  percentuais: PercentuaisType;
  motivos: MotivoType[];
}

interface ItensBiddingType {
  id: number;
  objeto: string;
  modalidade_sigla: string;
  orgao: {
    estado_id: number;
    codigo: string;
    cidade: string;
    estado: string;
  };
  resultados: Array<{
    cnpj: number;
    fornecedor: string;
    item_valor_total?: number;
  }>;
}
interface EmpresasType {
  id: number;
  name: string;
}
interface parceriasType {
  razao_social: string;
  cnpj: string;
  partner: {
    capital_social: string;
  };
}
interface cnaesType {
  id: number;
  codigo: string;
  descricao: string;
}
interface sociosType {
  id: number;
  empresa_id: number;
  nome: string;
  codigo_vinculo: number;
  descricao_vinculo: string;
}

export interface CompannyType {
  empresa: {
    abertura: string;
    bairro: string;
    capital_social: number;
    cep: string;
    cnaes: Array<cnaesType>;
    cnpj: string;
    codigo_natureza_juridica: number;
    complemento: null;
    created: string;
    data_situacao: string | null;
    data_situacao_especial: null;
    email: string;
    ente_federativo: null;
    id: number;
    logradouro: string;
    modified: string;
    motivo_situacao: null;
    municipio: string;
    natureza_juridica: string;
    nome_fantasia: null;
    numero: string;
    parcerias: Array<parceriasType>;
    porte: string;
    quadro_socios_administradores: Array<sociosType>;
    razao_social: string;
    sintegra: Array<any>;
    situacao: string;
    situacao_especial: null;
    telefone: string;
    tipo_empresa: string;
    uf: string;
  };
}

export interface SanctionsType {
  nomeSancionado: string;
  orgao: string;
  ufSancionado: string;
  tipoSancao: string;
  dataInicialSancao: string;
  id: number;
  dataFinalSancao: string;
  dataPublicacao: string;
}

export interface ApfType {
  observacao: string;
  tipo: string;
  emissor: string;
  descricao: string;
  situacao: string;
}

export interface FollowupsType {
  id: number;
  orgao_estado: string;
  orgao_cidade: string;
  edital: string;
  public_body: {
    nome: string;
  };
}

export interface ResultadosType {
  cnpj: string;
  fornecedor: string;
  item_descricao: string;
  item_quantidade: string;
  item_valor_total: number;
  item_valor_unitario: number;
  licitacao_id: number;
}

export interface ResultsType {
  resultados: Array<ResultadosType>;
  id: number;
}

export interface SanctionsListType {
  category: string;
  cnpj: string;
  name_company: string;
  penalty_end_date: string;
  penalty_start_date: string;
  portal: string;
  id: number;
  url: string;
  orgao_sancionador: string;
  available: boolean;
}

export interface BoardManagingPartnersTypes {
  descricao_vinculo: string;
  empresa_id: number;
}

export interface MembershipType {
  cnpj: string;
  name: string;
  id: number;
  quadro_socios_administradores: Array<BoardManagingPartnersTypes>;
  razao_social: string;
  companies: {
    empresas: Array<EmpresasType>;
  };
}

export interface ItensVencidosType {
  bidding_id: number | string | null;
  numero_item: string | null;
  descricao: string | null;
  quantidade: number | null;
  valor_unitario: number | null;
  valor_final: number | null;
  source_id: number;
}
export interface DisputasResumoType {
  quantidade: number;
  valor_total?: number;
  itens?: ItensVencidosType[];
}

export interface LicitacoesPorModalidadeType {
  modalidade: string;
  participacoes: number;
  valor_total: number;
  source_id: number;
}

export interface LicitacoesPorEstadoType {
  estado: string;
  participacoes: number;
  valor_total: number;
  source_id: number;
}

export interface PaginacaoListaType {
  page: number;
  total_itens: number;
  total_paginas: number;
}

export interface PaginacaoParticipacoesType {
  per_page: number;
  vencidos: PaginacaoListaType;
  nao_vencidos: PaginacaoListaType;
}

export interface ParticipacoesResumoType {
  participacoes: number;
  disputas_vencidas: DisputasResumoType;
  disputas_nao_vencidas: DisputasResumoType;
  licitacoes_por_modalidade: LicitacoesPorModalidadeType[];
  licitacoes_por_estado: LicitacoesPorEstadoType[];
}

export interface ConcurrentsType {
  view_panel: string;
  cnpj: string;
  company: Array<CompannyType>;
  sanctions: Array<SanctionsType>;
  apf: Array<ApfType>;
  penalties_sp: string;
  followups: Array<FollowupsType>;
  total_followup: number;
  total_results: number;
  results: Array<ResultsType>;
  sanctions_list: Array<SanctionsListType>;
  total_pages_sanctions: number;
  membership: Array<MembershipType>;
  itens_vencidos: {
    total: number;
    licitacoes: Array<ItensBiddingType>;
    estados: { [sigla: string]: number };
    modalidades: { [sigla: string]: number };
  };
  strategic_aspects: StrategicAspectsType;
  participacoes_resumo?: ParticipacoesResumoType;
  participacoes_paginacao?: PaginacaoParticipacoesType;
}

export interface RequestState {
  company: { loading: boolean; loaded: boolean; error: boolean };
  sanctions: { loading: boolean; loaded: boolean; error: boolean };
  get_apf: { loading: boolean; loaded: boolean; error: boolean };
  get_penalties_sp: { loading: boolean; loaded: boolean; error: boolean };
  get_followups: { loading: boolean; loaded: boolean; error: boolean };
  bidding_list: { loading: boolean; loaded: boolean; error: boolean };
  sanctions_list: { loading: boolean; loaded: boolean; error: boolean };
  membership_company: { loading: boolean; loaded: boolean; error: boolean };
  itens_vencidos: { loading: boolean; loaded: boolean; error: boolean };
  strategic_aspects: { loading: boolean; loaded: boolean; error: boolean };
  participacoes_resumo: { loading: boolean; loaded: boolean; error: boolean };
}

export interface ConcurrentsState {
  concurrents: ConcurrentsType;
  readonly request: RequestState;
}
